import { render, staticRenderFns } from "./sales_product_by_customer_analytic_index.vue?vue&type=template&id=92204d98&scoped=true&"
import script from "./sales_product_by_customer_analytic_index.vue?vue&type=script&lang=js&"
export * from "./sales_product_by_customer_analytic_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92204d98",
  null
  
)

export default component.exports